import { FR } from './france';

export const NC = FR;
